import { useMemo } from 'react';
import { PaperProps } from '@mui/material';
import { useAdminInvoiceQuery } from '../../../../api/gql';
import { ScheduledActionsTable } from '../../../../modules/admin/invoice/ScheduledActionsTable';

type Props = {
  invoiceId: string;
  transNs?: string;
  keyPrefix?: string;
} & PaperProps;

export const InvoiceScheduledActionsBox = ({ invoiceId, transNs, keyPrefix, ...rest }: Props) => {
  const { data, isLoading, isError } = useAdminInvoiceQuery({
    id: invoiceId,
  });

  const scheduledActions = useMemo(() => data?.adminInvoice.scheduledActions, [data?.adminInvoice.scheduledActions]);

  return (
    <ScheduledActionsTable
      keyPrefix={keyPrefix}
      transNs={transNs}
      scheduledActions={scheduledActions}
      isLoading={isLoading}
      isError={isError}
      {...rest}
    />
  );
};
